import { Box, Button, CssBaseline, DialogContent, DialogTitle, Grid, Input, List, ListItem, ListItemContent, ListItemDecorator, Modal, ModalDialog, Stack, Typography } from "@mui/joy";
import { BarChart } from "@mui/x-charts";
import { LineChart, lineElementClasses } from '@mui/x-charts/LineChart';
import axios from "axios";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { server_url } from '../core/config_geral'
import { KeyboardReturnOutlined, Reviews } from "@mui/icons-material";

async function doLoad(servidorUrl, token) {

    var formToSend = {
        action: "RETORNA_EVENTO_SITE_CASTOR_RPC",
        runNow: true,
        payload: ""
    }

    var formData = new FormData()
    formData.append("file", null);
    formData.append("data",
        new Blob([JSON.stringify(formToSend)], {
            type: "application/json"
        }))
    var r = await axios.post(servidorUrl + "/rpc", formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + token
        },
        responseType: "arraybuffer", // Importante para baixar binario
    }).then(response => response)
        .catch(error => error)

    if (r.status && (r.status === 200 || r.status === 201)) {
        let decoder = new TextDecoder('utf-8');
        let decodedString = decoder.decode(r.data);
        return JSON.parse(decodedString)
    }

    return false;
}

function processaReporte(registros, ipsRestritos = []) {
    const blocked = new Set(ipsRestritos);

    const validos = (registros || []).filter(e =>
        e?.ip &&
        e?.uri &&
        !blocked.has(e.ip) &&
        (e.occurredAt || e.data)
    );

    const toDia = d => d.toISOString().slice(0, 10);

    if (validos.length === 0) {
        return {
            intervalo: {
                inicio: toDia(new Date()),
                fim: toDia(new Date())
            },
            totais: {
                home: { total: 0, ipsUnicos: 0 },
                guias: { total: 0, ipsUnicos: 0 },
                comecar: { total: 0, ipsUnicos: 0 }
            },
            series: []
        };
    }


    const toDate = e => new Date(e.occurredAt ?? e.data);

    const datas = validos.map(toDate);
    const minDate = new Date(Math.min(...datas));
    const maxDate = new Date(Math.max(...datas));

    // gera intervalo completo
    const dias = [];
    for (let d = new Date(minDate); d <= maxDate; d.setDate(d.getDate() + 1)) {
        dias.push(toDia(new Date(d)));
    }

    const initDia = () => ({
        total: 0, ips: new Set()
    });

    const porDia = Object.fromEntries(dias.map(d => [d, initDia()]));

    // agregação diária
    for (const e of validos) {
        const dia = toDia(toDate(e));
        if (!porDia[dia]) continue;
        porDia[dia].total++;
        porDia[dia].ips.add(e.ip);

    }

    // totais globais
    const totais = {
        total : 0,
        ips : new Set(),
    };

    for (const d of dias) {
        totais.total += porDia[d].total;
        porDia[d].ips.forEach(ip => totais.ips.add(ip));
    }

   
    // normalização final
    return {
        intervalo: {
            inicio: toDia(minDate),
            fim: toDia(maxDate)
        },
        totais: {
            total : totais.total,
            ips: totais.ips.size,
        },
        series: dias.map(d => ({
            dia: d,
            total : porDia[d].total,
            ips: porDia[d].ips,
        }))
    };
}

function ipAllowed(obj) {
    const payload = typeof obj.payload === 'string'
        ? JSON.parse(obj.payload)
        : obj.payload || {};

    if (!payload.ip) return false;

    if (payload.ip.startsWith("74.7") ||
        payload.ip === "152.234.102.151") {
        return false;
    }

    return true;
}

function limpaData(response) {
    if (response === false) return [];

    return response.payload.
        filter(e => ipAllowed(e))
        .map(e => {
            const payload = typeof e.payload === 'string'
                ? JSON.parse(e.payload)
                : e.payload || {};

            return {
                id: e.id,
                data: new Date(e.occurredAt), // data tratada
                ip: payload.ip || null,
                host: payload.host || null,
                uri: payload.uri || null,
                method: payload.method || null,
                params: payload.params || []
            };
        });
}
function getParam(obj, chave) {
    if (!obj?.params || !Array.isArray(obj.params)) return null;

    const param = obj.params.find(p => p?.nome === chave);
    return param ? param.valor : null;
}
function processaDistribuicao(dados) {
    let f = dados.filter(e => {
        let p = getParam(e, "chosen_guia")
        return p != null;
    })

    f = f.filter(e => {
        return !e.uri.includes("/anano-castor")
    })
    const dict = {};

    for (const obj of f) {
        const valor = getParam(obj, "chosen_guia")
        if (!valor) continue;
        dict[valor] = (dict[valor] || 0) + 1;
    }
    const r = Object.entries(dict)
        .map(([key, count]) => ({ key, count }))
        .sort((a, b) => b.count - a.count);

    return r;
}

function TrackerDashBoard() {

    var token = useSelector((state) => state.auth.token)
    var url = server_url
    var [state, setState] = useState({
        data: [],
        dataFiltrada: [],
        loading: true,
        report: false,
        distribution: [],
    });

    var [modalOpen, setOpen] = useState({
        isOpen: false,
    })

    const [filtro, setFiltro] = useState({
        ar: [],
        q: null
    })

    const alteraFiltro = (e) => {

        const valor = e.target.value.length > 0 ? e.target.value : null;
        setFiltro(prev => ({ ...prev, q: valor }));
    }

    const addFiltro = () => {

        if (filtro.q == null) return;

        var ar = [...filtro.ar];
        ar.push(filtro.q);

        setFiltro(prev => ({
            ...prev,
            ar: ar,
            q: null,
        }))
    }

    const removeFiltro = (index) => {

        var arr = [...filtro.ar];

        if (index < 0 || index >= arr.length) {
            return;
        }

        arr.splice(index, 1);

        setFiltro(prev => ({
            ...prev,
            ar: arr
        }))

        filtrar();
    }

    const filtrar = () => {
        var nData = [...state.data]
        filtro.ar.forEach(ar => {
            nData = nData.filter(f => {
                if (ar == null) return true;

                if (JSON.stringify(f).includes(ar)) return true;

                return false;
            });
        })

        setState(prev => ({
            ...prev,
            dataFiltrada: nData,
            report: processaReporte(nData),
            distribution: processaDistribuicao(nData),
        }));
    }
    React.useEffect(() => {
        const hoje = new Date();
        const data15DiasAtras = new Date(hoje);
        data15DiasAtras.setDate(hoje.getDate() - 10);

        const load = async () => {
            const r = await doLoad(url, token);
            var data = limpaData(r);
            data = data.filter(d => {
                return d.data > data15DiasAtras
            })
            setState(prev => ({
                ...prev,
                loading: false,
                data: data,
                dataFiltrada: data,
                report: processaReporte(data),
                distribution: processaDistribuicao(data),
            }));
        };

        load();
    }, []);

    return <Grid container>
        <Grid xs={12}>
            Versao com CI
        </Grid>
        <Grid xs={12}>
            {state.loading && <Typography>loading...</Typography>}
        </Grid>
        <Grid xs={12}>
            lenght: {state.data.length}
        </Grid>
        <Grid xs={12}>
            filtered: {state.dataFiltrada.length}
        </Grid>
        <JsonListModalExample setOpen={setOpen} isOpen={modalOpen.isOpen} data={state.dataFiltrada} />
        <GuiasDistribution dist={state.distribution} />
        <Grid xs={12}>
            <Typography>Filtros</Typography>
            <Stack spacing={1}>
                {filtro.ar.map((ar, index) => {
                    return <Box key={index}>
                        <Stack direction="row" spacing={1}>
                            {ar} <Button color="danger" onClick={() => removeFiltro(index)}>x</Button>
                        </Stack>
                    </Box>;
                })}
                <Stack direction="row" spacing={1}>
                    <Input onChange={(e) => alteraFiltro(e)} />
                    <Button color="primary" onClick={addFiltro}>+</Button>
                </Stack>
                <Button color="primary" onClick={filtrar}>Filtrar</Button>
            </Stack>
        </Grid>
        <Grid xs={12}>
            {state.report !== false && <Charting
                data={state.report.series.map(e => e.ips.size)}
                labels={state.report.series.map(e => e.dia)}
                color="gray"
                tag="acessos home" />}
        </Grid>

        {/* <Grid xs={12}>
            {state.report !== false && <Charting 
                data={state.report.series.map(e => e.guiasIPs)} 
                convert={state.report.series.map(e => e.convertComecar)}
                labels={state.report.series.map(e => e.dia)} />}
        </Grid>
        <Grid xs={12}>
            {state.report !== false && <Charting 
                data={state.report.series.map(e => e.comecarIPs)} 
                convert={[]}
                labels={state.report.series.map(e => e.dia)} />}
        </Grid> */}

    </Grid>
}

function Charting(props) {

    const countData = props.data
    const labels = props.labels;
    const tag = props.tag;
    const color = props.color;
    const yAxis = props.yAxis ? props.yAxis : { width: 50 };
    const margin = { right: 24 };

    if (countData.length == 0 || labels.length == 0)
        return "# data ou labels invalido";

    return <Box sx={{ width: "100%", height: 300 }}>
        <BarChart
            series={[
                { data: countData, label: tag, area: true, stack: 'total', showMark: false, color: color },
                //   {
                //     data: amtData,
                //     label: 'amt',
                //     area: true,
                //     stack: 'total',
                //     showMark: false,
                //   },
            ]}
            xAxis={[{ scaleType: 'band', data: labels }]}
            yAxis={[yAxis]}
            sx={{
                [`& .${lineElementClasses.root}`]: {
                    display: 'none',
                },
            }}
            margin={margin}
        />
    </Box>
}

function GuiasDistribution(props) {
    return <Grid xs={12}>
        <Stack>
            {props.dist.map((e, index) => {
                return <Box key={index}>
                    <Typography>{e.key}: {e.count}</Typography>
                </Box>
            })}
        </Stack>
    </Grid>
}

function JsonListModalExample(props) {

    const data = props.data

    return (
        <>
            <CssBaseline />
            <Button onClick={() => props.setOpen(prev => ({ ...prev, isOpen: true }))}>Lista de resultados</Button>

            <Modal open={props.isOpen} onClose={() => props.setOpen(prev => ({ ...prev, isOpen: false }))}>
                <ModalDialog sx={{ width: "1000px" }}>
                    <DialogTitle>Lista de itens (JSON)</DialogTitle>

                    <DialogContent>
                        <Stack spacing={1}>
                            <Typography level="body-sm">
                                Itens: {data.length}
                            </Typography>
                            <List>
                                {data.map((item, key) => {

                                    console.log(item)

                                    return <ListItem key={key}>
                                        <ListItemDecorator>{key}</ListItemDecorator>
                                        <ListItemContent>
                                            <Typography level="title-sm">{item.id}</Typography>
                                            <Typography level="body-xs">{item.data.toISOString()}</Typography>
                                            <Typography level="body-xs">
                                                {item.ip} ({item.host})
                                            </Typography>
                                            <Typography level="body-xs" sx={{ maxWidth: "100%", wordWrap: "anywhere" }}>
                                                {item.method} {item.uri}
                                            </Typography>
                                            <Typography level="title-sm">Params:</Typography>
                                            {item.params.map((p, index) => {
                                                return <Typography key={index} level="body-xs" sx={{ maxWidth: "100%", wordWrap: "anywhere" }}>
                                                    {p.nome} : {p.valor}
                                                </Typography>
                                            })}
                                        </ListItemContent>
                                    </ListItem>
                                })}
                            </List>

                            <Button variant="outlined" onClick={() => props.setOpen((prev) => ({ ...prev, isOpen: false }))}>
                                Fechar
                            </Button>
                        </Stack>
                    </DialogContent>
                </ModalDialog>
            </Modal>
        </>
    );
}

export default TrackerDashBoard;